/**
 * Enum for different view/screen types
 */
export enum SourceViewType {
    ListView = 'LV',
    ReadingPane = 'RP',
}
